<script>
	import Helper from './components/Helper.svelte';
	import Input from './componentes/Forms/Input.svelte';
	import Modal from './components/Modal.svelte';
	import Titlesection from './components/Titlesection.svelte';
	import AnimationContainer from './components/AnimationContainer.svelte';
	import Navbar from './components/Navbar.svelte';
    import { push } from 'svelte-spa-router';
    import { urlapi, permisos, permisos_struct,permisos_title,miPermiso,iduser,login } from './stores/store';
    import { object2array, postData, isJson, mergeDeep, moneda } from './scripts';
    import moment from 'moment'

    export let params = {}

    /* PERMISOS */

    let viewPage=false;

    if($login===false)
    {
        push('/login')
    } else if(
                $miPermiso.clientes.access===false
                || ($miPermiso.clientes.edit!==true && parseInt(params.id)!==0)
                || ($miPermiso.clientes.insert!==true && parseInt(params.id)===0)
            ) {
        push('/sinpermiso')
    } else {
        viewPage=true;
    }
    /* FIN PERMISOS */

    // campos
    let id=false;
    let helper=false;
    let tipo_identificacion='NIT';
    let nit='';
    let nombre='';
    let apellidos='';
    let fechaNacimiento=null;
    let direccion='';
    let telefono='';
    let correo='';

    let status='1';
    
    let fecha_creacion=null;
    let fecha_ultima_actualizacion=null;
    let fecha_ultima_compra=null;
    let cantidad_facturas=null;
    let total_compras=null;
    let saldo=null;

    // status
    let disabled=false;
    let guardando=false;
    let insertando=false;

    let function_salir = function () { push('/clientes'); }

    let function_delete=function()
    {
        disabled=true;
        guardando=true;
        postData($urlapi, [{ 
            id,
            'cmd':'clientes_delete' 
        }])
        .then(data => {
            guardando=false;
            disabled=false;
            function_salir();
        });
    }
    
    let save=async function()
    {
        disabled=true;
        guardando=true;

        const res = await postData($urlapi, [{ 
            id,
            tipo_identificacion,
            nit,
            nombre,
            apellidos,
            fechaNacimiento,
            direccion,
            telefono,
            correo,
            status,
            insertando,
            'cmd':'clientes_save' 
        }])
        .then(data => {
            guardando=false;
            disabled=false;
            console.log(data)
            //function_salir();
        });       
    }

    let load=function()
    {
        postData($urlapi, [{ 'id':id, 'cmd':'clientes_edit' }])
        .then(data => {
            if(data[0].result===false) {
                function_salir();
            } else {
                
                tipo_identificacion=data[0].result.tipo_identificacion;
                nit=data[0].result.nit;
                nombre=data[0].result.nombre;
                apellidos=data[0].result.apellidos;
                fechaNacimiento=data[0].result.fecha_nacimiento;
                direccion=data[0].result.direccion;
                telefono=data[0].result.telefono;
                correo=data[0].result.correo;
                status=data[0].result.status;

                fecha_creacion=data[0].result.fecha_creacion;
                fecha_ultima_actualizacion=data[0].result.fecha_ultima_actualizacion;
                fecha_ultima_compra=data[0].result.fecha_ultima_compra;
                cantidad_facturas=data[0].result.cantidad_facturas;
                total_compras=data[0].result.total_compras;
                saldo=data[0].result.saldo;

            }
        });        
    }

    let handleKeydown=function(event) { 
        if(event.keyCode==13) save()
        if(event.keyCode==27) function_salir()
    }

    if(params.id!=0)
    {
        insertando=false;
        id=params.id;
        load();
    } else {
        insertando=true;
        id=0;
    }

</script>

<svelte:window on:keydown={handleKeydown}/>

{#if viewPage===true}

<Navbar />

<AnimationContainer marginTop=0>
    <Titlesection>
        <span slot="title"><i class="bi bi-person-square me-1" />Clientes
        <small class='badge bg-light text-success text-uppercase'>
        {#if insertando===true}
            Nuevo
        {:else}
            ID {id}
        {/if}
        </small>
        
        </span>
        <span slot="toolbar">
            <button {disabled} class="btn btn-success" on:click={save} on:mouseenter={()=>helper='Guardar'} on:mouseleave={()=>helper=false}>
                {#if guardando===true}
                    <span class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                {/if}                
                <i class="bi bi-save"></i></button>
                <Modal classButton='btn-warning btn-sm' iconButton='bi-box-arrow-left' functionSi={function_salir} title='ADVERTENCIA' {disabled} on:mouseenter={()=>helper='Salir'} on:mouseleave={()=>helper=false}>
                    Esta seguro que desea <strong>Salir</strong>?<br/>
                    Se perderán los cambios realizados
                </Modal>                
        </span>
    </Titlesection>

    <br/>
    <div class="row">
        <div class="col-12 col-md-6">

            <h6 class='fw-bold text-uppercase text-warning'>Datos</h6>

            <div><Input label='Tipo de Identificación' bind:value={tipo_identificacion} tipo='select' datos={['NIT','DPI']} class='mb-2' {disabled} /></div>
            <div><Input label='NIT/DPI' bind:value={nit} class='mb-2' {disabled} autofocus/></div>  <!-- PENDIENTE -->
            <div><Input label='Nombre' bind:value={nombre} class='mb-2' {disabled} /></div>
            <div><Input label='Apellidos' bind:value={apellidos} class='mb-2' {disabled}/></div>
            <div><Input label='Fecha Nacimiento' bind:value={fechaNacimiento} tipo='date' class='mb-2' {disabled}/></div>
            <div><Input label='Dirección' bind:value={direccion} class='mb-2' {disabled}/></div>
            <div><Input label='Teléfono' bind:value={telefono} class='mb-2' {disabled}/></div>
            <div><Input label='Correo' bind:value={correo} tipo='email' class='mb-2' {disabled}/></div>

            <div><Input label='Status' bind:value={status} tipo='select' 
                        datos={[{'0':'NO ACTIVO'},{'1':'ACTIVO'}]} 
                        class='mb-2 {(status=='1')?'text-success':'text-danger'}' {disabled} />
            </div>

            <br/><br/>
        </div>
        <div class="col-12 col-md-6">
            <h6 class='fw-bold text-uppercase text-warning mb-0'>Fecha de creación</h6>
            <p class='text-secondary ms-2'>
                {#if fecha_ultima_actualizacion===null}
                     Aún no fue creada
                {:else}
                    {moment(fecha_creacion).format("DD-MM-YYYY HH:mm:ss")}
                {/if}                
            </p>
            
            <h6 class='fw-bold text-uppercase text-warning mb-0'>Fecha última actualización</h6>
            <p class='text-secondary ms-2'>
                {#if fecha_ultima_actualizacion===null}
                     Sin actualizaciones
                {:else}
                    {moment(fecha_ultima_actualizacion).format("DD-MM-YYYY HH:mm:ss")}
                {/if}
            </p>

            <h6 class='fw-bold text-uppercase text-warning mb-0'>Fecha última compra</h6>
            <p class='text-secondary ms-2'>
                {#if fecha_ultima_compra===null}
                     Sin compras
                {:else}
                    {moment(fecha_ultima_compra).format("DD-MM-YYYY HH:mm:ss")}
                {/if}                
            </p>

            <h6 class='fw-bold text-uppercase text-warning mb-0'>Cantidad de facturas</h6>
            <p class='text-secondary ms-2'>{parseInt(cantidad_facturas*1)}</p>
            
            <h6 class='fw-bold text-uppercase text-warning mb-0'>Total de compras</h6>
            <p class='text-secondary ms-2'>{moneda(total_compras, 'Q.')}</p>

            <h6 class='fw-bold text-uppercase text-warning mb-0'>Saldo</h6>
            <p class='text-secondary ms-2'>{moneda(saldo, 'Q.')}</p>

        </div>
    </div>
    <!-- <div class="row">
        <div class="col-12 col-md-6">
                <br/>
                <hr>
                
                <Modal textButton='Eliminar cliente' classButton='btn-danger btn-sm' iconButton='bi-trash' functionSi={function_delete} title='ADVERTENCIA' {disabled}>
                    Esta seguro que desea <strong>Eliminar</strong> el cliente?<br/>
                    Se perderán todos los datos del cliente.
                </Modal>
            <br/><br/>   
        </div>
    </div> -->
    
    <Helper bind:text={helper}></Helper>
</AnimationContainer>

{/if}